<div (click)="goToArea()"
  class="group relative h-64 cursor-pointer overflow-hidden rounded-2xl border border-white/20 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:border-primary/50">
  <img [src]="thumbnail" [alt]="safeAreaName"
    class="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110" />

  <div class="absolute inset-0 bg-gradient-to-t from-bg-base via-bg-base/60 to-transparent"></div>

  <div class="absolute bottom-0 left-0 right-0 p-6 z-10">
    <div class="flex items-center justify-between">
      <div>
        <h3 class="mb-1 text-lg font-semibold text-text-primary">{{ safeAreaName }}</h3>
        <p class="text-sm text-text-secondary">{{ propertiesText }}</p>
      </div>

      <div *ngIf="isFeatured"
        class="inline-flex items-center gap-1 rounded-full bg-gradient-to-r from-primary to-primary-deep px-3 py-1 text-xs font-medium text-white shadow-md">
         <span>Featured</span>
      </div>
    </div>
  </div>

  <div class="absolute inset-0 bg-primary/0 transition-colors duration-300 group-hover:bg-primary/20 pointer-events-none"></div>
</div>
